var map = {
	"./about.jpg": 2741,
	"./accounts.jpg": 5820,
	"./bookkeeping.jpg": 7726,
	"./budget.jpg": 9751,
	"./gb.png": 2411,
	"./help.jpg": 2057,
	"./homeBanner.jpg": 51,
	"./homeBanner2.jpg": 7897,
	"./logo.png": 7169,
	"./logo_full.png": 4433,
	"./payroll.jpg": 8505,
	"./ro.png": 3685,
	"./ru.png": 1263,
	"./saving.jpg": 9746,
	"./selfemployed.jpg": 6491,
	"./selfemployed2.jpg": 8177,
	"./service.jpg": 1451,
	"./temp_img1.jpg": 8913,
	"./vat.jpg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4827;